module.exports = __webpack_public_path__ + "static/media/LRLE04.a22c25e3.jpg";